import { getTherapistCalendar } from "@/lib/therapist-scheduling/api";
import type { TherapistCalendarResponse } from "@/lib/therapist-scheduling/types";
import { useAbortableResource } from "./use-abortable-resource";

/**
 * Fetches one therapist's per-day calendar over a range (Visit 2++ continuity).
 * §8 enabled gate: therapistId && start_date && end_date.
 */
export function useTherapistCalendar(
	therapistId: string | null | undefined,
	startDate: string | null | undefined,
	endDate: string | null | undefined,
) {
	const enabled = !!therapistId && !!startDate && !!endDate;

	return useAbortableResource<TherapistCalendarResponse>(
		(signal) =>
			getTherapistCalendar(
				therapistId as string,
				{ start_date: startDate as string, end_date: endDate as string },
				{ signal },
			),
		{ enabled, key: JSON.stringify({ therapistId, startDate, endDate }) },
	);
}
